/**
 * triggers service
 */

import Resource from './resource'

export default new Resource('triggers')



// WEBPACK FOOTER //
// ./src/libraries/services/triggers.js